import React, { useState, useEffect, useRef } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
// import Data from "../../dummy";
// import PaginatedJobs from "./PaginatedJobs";
import FormProcessingSpinner from "../../common/FormProcessingSpinner"
import { useSelector } from "react-redux"
import * as paths from "../../../constants/paths"


const FilterBox = ({ title, name, children, openFilter, toggleFilterBox }) => {
  const isOpen = openFilter === name
  const boxRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && boxRef.current && !boxRef.current.contains(e.target)) {
        toggleFilterBox(null)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [isOpen, toggleFilterBox])

  return (
    <div ref={boxRef} className={`select_box ${isOpen ? "open" : ""}`}>
      <button
        type="button"
        className="input drop_btn d-flex justify-content-between"
        onClick={() => toggleFilterBox(name)}
      >
        <span>{title}</span>
        <i className={`chevron ${isOpen ? "open" : ""}`}></i>
      </button>

      {isOpen && <div className="select_list">{children}</div>}
    </div>
  )
}

export default function FindSearch({
  data,
  jobs,
  cities,
  types,
  cats,
  searchJobs,
  degree_req,
  isSearching,
  saveJob,
  isJobSaving,
  industries,
  isJobApplying,
  handleJobApply,
  isJobReporting,
  handleReportAnJob,
  handleShowSigninPopup,
  showSigninPopup,
  showReportPopup,
  handleToggleReportPopup,
  totalJobs,
  is_global_val,
  pageNo,
  setPageNo,
}) {
  let defaultTypesState = {}
  let defaultSubTypes = {}

  const searchField = useRef(null)
  const navigate = useNavigate()
  const authToken = useSelector((state) => state.fetchSignin.authToken)
  const plan = useSelector((state) => state.fetchSiteSettings.plan)
  const [showSubscripitionPopup, setShowSubscriptionPopup] = useState(false)

  const [searchParams] = useSearchParams()
  const { page } = useParams()
  const [active, setActive] = useState(false)
  const [sortBy, setSortBy] = useState("desc")
  const [jobCats, setJobCats] = useState({})
  const [jobRequirements, setJobRequirements] = useState({})
  const [citiesFilter, setCitiesFilter] = useState({})
  const [tpyesFilter, settypesFilter] = useState(defaultTypesState)
  const [subTypesFilter, setSubTypesFilter] = useState(defaultSubTypes)
  const [visaAcceptance, setVisaAcceptance] = useState(false)
  const [applicantsOutUk, setApplicantsOutUk] = useState(false)
  const [search, setSearch] = useState(searchParams.get("search"))
  const [searchByField, setSearchByField] = useState(false)
  const [isFilterApplied, setIsFilterApplied] = useState(false)

  const [filter, setFilter] = useState(false)
  const [is_global, setIsGlobal] = useState(
    searchParams.get("global") === "true" || searchParams.get("global") === true
      ? 1
      : searchParams.get("is_global") === "true" ||
        searchParams.get("is_global") === true
      ? 1
      : 0
  )
  const NO_OF_BLOCKS = 4
  const [firstJobsIndex, setFirstJobsIndex] = useState(NO_OF_BLOCKS)
  const filteredIndustries = industries.slice(0, firstJobsIndex)

  const [secondJobsIndex, setSecondJobsIndex] = useState(NO_OF_BLOCKS)
  const filteredLocations = cities.slice(0, secondJobsIndex)
  // const [pageNo, setPageNo] = useState(page);
  const isAlreadyInBasePath =
    typeof window !== "undefined" &&
    window.location.pathname.includes(`${paths.SITE_BASE_URL}`)
  const basePath = isAlreadyInBasePath ? "" : `${paths.SITE_BASE_URL}`
  const ToggleFilter = () => {
    setFilter(!filter)
  }

  if (searchParams.has("search")) {
    if (!plan) {
      navigate(basePath + "/subscription")
    }
  }

  const LoadMoreFirst = () => {
    setFirstJobsIndex(industries.length)
  }

  const LoadMoreSecond = () => {
    setSecondJobsIndex(cities.length)
  }

  const resetFirst = () => {
    setFirstJobsIndex(NO_OF_BLOCKS)
  }

  const resetSecond = () => {
    setSecondJobsIndex(NO_OF_BLOCKS)
  }

  const toggleFilter = () => {
    setActive(!active)
  }

  const handleJobCatsChange = (event) => {
    setIsFilterApplied(true)
    setJobCats({
      ...jobCats,
      [event.target.id]: event.target.checked,
    })
  }

  const handleDegreeRequirementChange = (event) => {
    setIsFilterApplied(true)
    setJobRequirements({
      ...jobRequirements,
      [event.target.id]: event.target.checked,
    })
  }

  const handleCityChange = (event) => {
    setIsFilterApplied(true)

    setCitiesFilter({
      ...citiesFilter,
      [event.target.id]: event.target.checked,
    })
  }

  const handleTypesChange = (event, sub_cats) => {
    // setIsFilterApplied(true);

    let typesCurrent = { ...subTypesFilter }
    sub_cats.map((row) => {
      return (typesCurrent = {
        ...typesCurrent,
        [event.target.id + "-" + row.id]: event.target.checked,
      })
    })

    setSubTypesFilter(typesCurrent)
    settypesFilter({
      ...tpyesFilter,
      [event.target.id]: event.target.checked,
    })
  }

  const handleSubtypesChangeChange = (event, sub_cats) => {
    // setIsFilterApplied(true);
    let mainCat = event.target.getAttribute("data-cat")
    let subCatsId = []

    sub_cats.map((row) => {
      return subCatsId.push(parseInt(row.id))
    })

    let subTypesCurrent = {}
    subTypesCurrent = {
      ...subTypesFilter,
      [event.target.id]: event.target.checked,
    }

    if (event.target.checked) {
      let checkedSubCatsLength = 0
      for (let prop in subTypesCurrent) {
        prop = parseInt(prop)
        if (subCatsId.includes(prop)) {
          if (subTypesCurrent[prop]) {
            checkedSubCatsLength++
          }
        }
      }

      if (checkedSubCatsLength === sub_cats.length) {
        settypesFilter({
          ...tpyesFilter,
          [mainCat]: true,
        })
      }
    } else {
      settypesFilter({
        ...tpyesFilter,
        [mainCat]: false,
      })
    }

    setSubTypesFilter({
      ...subTypesFilter,
      [event.target.id]: event.target.checked,
    })
  }

  const handleSearchChange = (event) => {
    setIsFilterApplied(true)
    setSearch(event.target.value)
  }

  const handleSetVisaAcceptance = () => {
    setIsFilterApplied(true)
    setVisaAcceptance(!visaAcceptance)
  }

  const handleSetApplicantsOutUk = () => {
    setIsFilterApplied(true)
    setApplicantsOutUk(!applicantsOutUk)
  }

  const handleToggleSubscriptionPopup = () => {
    setShowSubscriptionPopup(!showSubscripitionPopup)
  }

  const handleSearchFromField = () => {
    if (!plan) {
      // window.location.replace("/subscription");

      navigate(basePath + "/subscription")

      return false
    }

    setIsFilterApplied(true)
    navigate(basePath + "/find-jobs/1")
    setPageNo(1)
    const params = Object.fromEntries([...searchParams.entries()])
    let isGlobal = null
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1)
      isGlobal = 1
    } else {
      setIsGlobal(0)
    }
    handleSearchJobs(isGlobal)
  }

  // document.addEventListener("keypress", (e) => {
  //   if (e.code === "Enter") {
  //     if (document.activeElement === searchField.current) {
  //       e.preventDefault();
  //       handleSearchFromField();
  //     }
  //   }
  // });

  const handleSearchFormSubmit = (e) => {
    e.preventDefault()
    handleSearchFromField()
  }

  const handleSortByChange = (val) => {
    ToggleFilter()
    setSortBy(val)
  }

  const handleApplyFilters = () => {
    if (!plan) {
      // window.location.replace("/subscription");

      navigate(basePath + "/subscription")
      return false
    }

    navigate(basePath + "/find-jobs/1")
    setPageNo(1)
    const params = Object.fromEntries([...searchParams.entries()])
    let isGlobal = null
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1)
      isGlobal = 1
    } else {
      setIsGlobal(0)
    }
    handleSearchJobs(isGlobal)
  }

  useEffect(() => {
    const params = Object.fromEntries([...searchParams.entries()])
    let isGlobal = null
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1)
      isGlobal = 1
    } else {
      setIsGlobal(0)
    }
    const paramsObject = getUrlParamsObject()

    handleSearchJobs(isGlobal, paramsObject)
  }, [sortBy, is_global])

  // const handleClearAllFilter = () => {
  //   setSortBy("desc");
  //   setJobCats({});
  //   setJobRequirements({});
  //   setCitiesFilter({});
  //   settypesFilter({});
  //   setSubTypesFilter({});
  //   setVisaAcceptance(false);
  //   setApplicantsOutUk(false);
  //   // setSearch(searchParams.get("search"));
  //   setSearch(null);
  //   //call search
  //   setIsFilterApplied(false);
  //   const params = Object.fromEntries([...searchParams.entries()]);
  //   let isGlobal = null;
  //   if (
  //     (params.is_global &&
  //       params.is_global !== undefined &&
  //       params.is_global !== "undefined" &&
  //       params.is_global !== null &&
  //       params.is_global !== "null" &&
  //       params.is_global !== true &&
  //       params.is_global !== "true" &&
  //       params.is_global !== "0" &&
  //       params.is_global !== 0) ||
  //     params.is_global === 1 ||
  //     params.global === "1"
  //   ) {
  //     setIsGlobal(1);
  //     isGlobal = 1;
  //   } else {
  //     setIsGlobal(0);
  //   }
  //   handleSearchJobs(isGlobal);
  // };

  const handleClearAllFilter = () => {
    setSortBy("desc")
    setJobCats({})
    setJobRequirements({})
    setCitiesFilter({})
    settypesFilter({})
    setSubTypesFilter({})
    setVisaAcceptance(false)
    setApplicantsOutUk(false)
    setSearch(null)
    setIsFilterApplied(false)

    const params = Object.fromEntries([...searchParams.entries()])
    const isGlobal = params.is_global === "1" || params.global === "1" ? 1 : 0

    // 👇 send EMPTY filters explicitly
    searchJobs({
      sortBy: "desc",
      jobCats: [],
      cities: [],
      types: [],
      subTypes: [],
      jobRequirements: [],
      visaAcceptance: false,
      applicants_outside_uk: false,
      searchKeyword: null,
      pageNo: 1,
      is_global: isGlobal,
    })
  }

  const getUrlParamsObject = () => {
    const paramsObject = {}
    // ✅ Read parameters from the URL
    const params = Object.fromEntries([...searchParams.entries()])
    // ✅ Example: search term
    if (params.searchKeyword) {
      paramsObject.searchKeyword = params.searchKeyword
    }
    let isGlobal = null
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      paramsObject.is_global = 1
    } else {
      paramsObject.is_global = 0
    }

    // ✅ Example: job categories (comma-separated IDs)
    if (params.jobCats) {
      const jobCatsFromUrl = {}
      params.jobCats.split(",").forEach((id) => {
        jobCatsFromUrl[id] = true
      })
      paramsObject.jobCats = jobCatsFromUrl
    }

    // ✅ Example: cities filter
    if (params.cities) {
      const citiesFromUrl = {}
      params.cities.split(",").forEach((id) => {
        citiesFromUrl[id] = true
      })
      paramsObject.cities = citiesFromUrl
    }

    // ✅ Example: job types
    if (params.types) {
      const typesFromUrl = {}
      params.types.split(",").forEach((id) => {
        typesFromUrl[id] = true
      })
      paramsObject.types = typesFromUrl
    }

    // ✅ Example: sub types
    if (params.subTypes) {
      const subTypesFromUrl = {}
      params.subTypes.split(",").forEach((id) => {
        subTypesFromUrl[id] = true
      })
      paramsObject.subTypes = subTypesFromUrl
    }

    // ✅ Example: degree requirements
    if (params.jobRequirements) {
      const reqFromUrl = {}
      params.jobRequirements.split(",").forEach((id) => {
        reqFromUrl[id] = true
      })
      paramsObject.jobRequirements = reqFromUrl
    }

    // ✅ Example: boolean filters
    if (params.visaAcceptance === "true") {
      paramsObject.visaAcceptance = true
    }
    if (params.applicants_outside_uk === "true") {
      paramsObject.applicants_outside_uk = true
    }

    // ✅ Sort By
    if (params.sortBy) {
      paramsObject.sortBy = params.sortBy
    }

    // ✅ Page number
    if (params.pageNo) {
      paramsObject.pageNo = Number(params.pageNo)
    }
    return paramsObject
  }
  useEffect(() => {
    // ✅ Read parameters from the URL
    const params = Object.fromEntries([...searchParams.entries()])
    // ✅ Example: search term
    if (params.searchKeyword) {
      setSearch(params.searchKeyword)
    }
    let isGlobal = null
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1)
      isGlobal = 1
    } else {
      setIsGlobal(0)
    }

    // ✅ Example: job categories (comma-separated IDs)
    if (params.jobCats) {
      const jobCatsFromUrl = {}
      params.jobCats.split(",").forEach((id) => {
        jobCatsFromUrl[id] = true
      })
      setJobCats(jobCatsFromUrl)
    }

    // ✅ Example: cities filter
    if (params.cities) {
      const citiesFromUrl = {}
      params.cities.split(",").forEach((id) => {
        citiesFromUrl[id] = true
      })
      setCitiesFilter(citiesFromUrl)
    }

    // ✅ Example: job types
    if (params.types) {
      const typesFromUrl = {}
      params.types.split(",").forEach((id) => {
        typesFromUrl[id] = true
      })
      settypesFilter(typesFromUrl)
    }

    // ✅ Example: sub types
    if (params.subTypes) {
      const subTypesFromUrl = {}
      params.subTypes.split(",").forEach((id) => {
        subTypesFromUrl[id] = true
      })
      setSubTypesFilter(subTypesFromUrl)
    }

    // ✅ Example: degree requirements
    if (params.jobRequirements) {
      const reqFromUrl = {}
      params.jobRequirements.split(",").forEach((id) => {
        reqFromUrl[id] = true
      })
      setJobRequirements(reqFromUrl)
    }

    // ✅ Example: boolean filters
    if (params.visaAcceptance === "true") {
      setVisaAcceptance(true)
    }
    if (params.applicants_outside_uk === "true") {
      setApplicantsOutUk(true)
    }

    // ✅ Sort By
    if (params.sortBy) {
      setSortBy(params.sortBy)
    }

    // ✅ Page number
    // if (params.pageNo) {
    //   setPageNo(Number(params.pageNo));
    // }
    const paramsObject = getUrlParamsObject()
    // ✅ After setting filters, fetch jobs
    handleSearchJobs(isGlobal, paramsObject)
  }, [])
  const handleSearchJobs = (isGlobal = null, paramsObject = null) => {
    setActive(false)
    // alert();

    let jobCatsArr = []
    for (let key in jobCats) {
      if (jobCats[key]) jobCatsArr.push(key)
    }
    if (jobCatsArr.length === 0 && paramsObject && paramsObject.jobCats) {
      for (let key in paramsObject.jobCats) {
        if (paramsObject.jobCats[key]) jobCatsArr.push(key)
      }
    }

    let citiesFilterArr = []
    for (let key in citiesFilter) {
      if (citiesFilter[key]) citiesFilterArr.push(key.toString())
    }
    if (citiesFilterArr.length === 0 && paramsObject && paramsObject.cities) {
      for (let key in paramsObject.cities) {
        if (paramsObject.cities[key]) citiesFilterArr.push(key)
      }
    }

    let tpyesFilterArr = []
    for (let key in tpyesFilter) {
      if (tpyesFilter[key]) tpyesFilterArr.push(key.toString())
    }
    if (tpyesFilterArr.length === 0 && paramsObject && paramsObject.types) {
      for (let key in paramsObject.types) {
        if (paramsObject.types[key]) tpyesFilterArr.push(key)
      }
    }

    let subTypesFilterArr = []
    for (let key in subTypesFilter) {
      if (subTypesFilter[key]) subTypesFilterArr.push(key.toString())
    }
    if (
      subTypesFilterArr.length === 0 &&
      paramsObject &&
      paramsObject.subTypes
    ) {
      for (let key in paramsObject.subTypes) {
        if (paramsObject.subTypes[key]) subTypesFilterArr.push(key)
      }
    }

    let degreeRequirementsArr = []
    for (let key in jobRequirements) {
      if (jobRequirements[key]) degreeRequirementsArr.push(key.toString())
    }
    if (
      degreeRequirementsArr.length === 0 &&
      paramsObject &&
      paramsObject.jobRequirements
    ) {
      for (let key in paramsObject.jobRequirements) {
        if (paramsObject.jobRequirements[key]) degreeRequirementsArr.push(key)
      }
    }

    let filters = {}
    filters = {
      sortBy: sortBy,
      jobCats: jobCatsArr,
      cities: citiesFilterArr,
      types: tpyesFilterArr,
      jobRequirements: degreeRequirementsArr,
      visaAcceptance: visaAcceptance,
      applicants_outside_uk: applicantsOutUk,
      searchKeyword: search,
      subTypes: subTypesFilterArr,
      // minPrice: minPrice,
      // maxPrice: maxPrice
      pageNo: pageNo,
      is_global: is_global
        ? is_global
        : isGlobal !== null
        ? isGlobal
        : is_global,
    }
    if (
      filters?.searchKeyword === null ||
      filters?.searchKeyword === "null" ||
      filters?.searchKeyword === undefined ||
      filters?.searchKeyword === "undefined"
    ) {
      const params = Object.fromEntries([...searchParams.entries()])
      if (params.searchKeyword) {
        filters.searchKeyword = params.searchKeyword
      }
    }
    // console.log("paramsObject", paramsObject);
    filters = { ...paramsObject, ...filters }
    // console.log("filters", filters,);
    searchJobs(filters)
  }

  useEffect(() => {
    const params = Object.fromEntries([...searchParams.entries()])
    let isGlobal = null
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1)
      isGlobal = 1
    } else {
      setIsGlobal(0)
    }

    if (pageNo > 2 && !plan) {
      navigate(basePath + "/subscription")
    } else {
      const paramsObject = getUrlParamsObject()
      handleSearchJobs(isGlobal, paramsObject)
    }
  }, [pageNo])

  const [openFilter, setOpenFilter] = useState(null)

  const toggleFilterBox = (name) => {
    setOpenFilter(openFilter === name ? null : name)
  }

  const getActiveFilters = () => {
    let filters = []

    // 🔹 Job Industry
    Object.keys(jobCats).forEach((key) => {
      if (jobCats[key]) {
        const industry = industries.find(
          (i) => `industry-${i.id}` === key || i.id == key
        )
        if (industry) {
          filters.push({
            key,
            label: industry.title,
            onRemove: () => setJobCats((prev) => ({ ...prev, [key]: false })),
          })
        }
      }
    })

    // 🔹 Location
    Object.keys(citiesFilter).forEach((key) => {
      if (citiesFilter[key]) {
        const city = cities.find((c) => `city-${c.id}` === key || c.id == key)
        if (city) {
          filters.push({
            key,
            label: city.title,
            onRemove: () =>
              setCitiesFilter((prev) => ({ ...prev, [key]: false })),
          })
        }
      }
    })

    // 🔹 Job Type
    Object.keys(tpyesFilter).forEach((key) => {
      if (tpyesFilter[key]) {
        const type = cats.find((c) => c.id == key)
        if (type) {
          filters.push({
            key,
            label: type.title,
            onRemove: () =>
              settypesFilter((prev) => ({ ...prev, [key]: false })),
          })
        }
      }
    })

    // 🔹 Degree Requirement
    Object.keys(jobRequirements).forEach((key) => {
      if (jobRequirements[key]) {
        const degree = degree_req.find(
          (d) => `degree-${d.id}` === key || d.id == key
        )
        if (degree) {
          filters.push({
            key,
            label: degree.title,
            onRemove: () =>
              setJobRequirements((prev) => ({ ...prev, [key]: false })),
          })
        }
      }
    })

    // 🔹 Suitable For
    if (visaAcceptance) {
      filters.push({
        key: "visa",
        label: "Graduate Visa holders",
        onRemove: () => setVisaAcceptance(false),
      })
    }

    if (applicantsOutUk) {
      filters.push({
        key: "outside_uk",
        label: "Applicants outside UK",
        onRemove: () => setApplicantsOutUk(false),
      })
    }

    return filters
  }

  return (
    <>
      <form action="" method="post">
        <div className="find_search">
          {/* <div className="tab_block">
            <button type="button" className="active">
              <img src="/images/icon_search.png" alt="" />
              Search
            </button>
            <button type="button">
              <img src="/images/icon_mini_bookmark_fill.png" alt="" />
              Saved Jobs
            </button>
            <button type="button">
              <img src="/images/icon_mini_clock.png" alt="" />
              Recent
            </button>
          </div> */}
          <div className="row form_row">
            <div className="col-md-12">
              <div className="form_blk flex_blk">
                <div className="relative flex-grow-1 me-3 flex_blk_in">
                  <img src="/images/icon_search.png" alt="" />
                  <input
                    type="text"
                    name="search"
                    id="search"
                    value={search}
                    onChange={handleSearchChange}
                    className="input"
                    placeholder="Job title, keywords, or company"
                    autoComplete="off"
                    ref={searchField}
                  />
                </div>
                <button
                  type="button"
                  className="site_btn"
                  onClick={handleSearchFromField}
                  disabled={isSearching}
                >
                  Search
                  <img src="/images/icon_arrow_right.png" alt="" />
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <FilterBox
                title="Job Type"
                name="job_type"
                openFilter={openFilter}
                toggleFilterBox={toggleFilterBox}
              >
                <ul className="ctg_lst">
                  {cats.map((cat, key) => (
                    <li key={key}>
                      <label htmlFor={cat.id}>
                        <input
                          type="checkbox"
                          value={cat.id}
                          id={cat.id}
                          name="job_type"
                          onChange={(e) => handleTypesChange(e, cat.sub_cats)}
                          checked={tpyesFilter[cat.id]}
                        />
                        {cat.title}
                        {cat.count ? <span> ({cat.count})</span> : null}
                      </label>

                      <ul>
                        {cat.sub_cats &&
                          cat.sub_cats.map((sub) => (
                            <li key={sub.id}>
                              <div className="lbl_btn ms-3">
                                <input
                                  data-cat={cat.id}
                                  type="checkbox"
                                  value={sub.id}
                                  id={cat.id + "-" + sub.id}
                                  name="job_sub"
                                  onChange={(e) =>
                                    handleSubtypesChangeChange(e, cat.sub_cats)
                                  }
                                  checked={
                                    subTypesFilter[cat.id + "-" + sub.id]
                                  }
                                />
                                <label htmlFor={cat.id + "-" + sub.id}>
                                  {sub.title}
                                </label>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </FilterBox>
            </div>

            {is_global === 0 && (
              <div className="col-md-4">
                <FilterBox
                  title="Degree Requirement"
                  name="degree"
                  openFilter={openFilter}
                  toggleFilterBox={toggleFilterBox}
                >
                  <ul className="ctg_lst">
                    {degree_req.map((dr, key) => (
                      <li key={key}>
                        <label htmlFor={"degree-" + dr.id}>
                          <input
                            type="checkbox"
                            value={dr.id}
                            id={"degree-" + dr.id}
                            name="degree_req"
                            onChange={handleDegreeRequirementChange}
                            checked={
                              jobRequirements[dr.id] ||
                              jobRequirements["degree-" + dr.id]
                            }
                          />
                          {dr.title}
                          {dr.count ? <span> ({dr.count})</span> : null}
                        </label>
                      </li>
                    ))}
                  </ul>
                </FilterBox>
              </div>
            )}

            <div className="col-md-4">
              <FilterBox
                title="Job Industry"
                name="industry"
                openFilter={openFilter}
                toggleFilterBox={toggleFilterBox}
              >
                <ul className="ctg_lst">
                  {filteredIndustries.map((industry, key) => (
                    <li key={key}>
                      <label htmlFor={"industry-" + industry.id}>
                        <input
                          type="checkbox"
                          value={industry.id}
                          id={"industry-" + industry.id}
                          name="job_cat"
                          onChange={handleJobCatsChange}
                          checked={
                            jobCats[industry.id] ||
                            jobCats["industry-" + industry.id]
                          }
                        />
                        {industry.title}
                        {industry.count ? (
                          <span> ({industry.count})</span>
                        ) : null}
                      </label>
                    </li>
                  ))}
                </ul>

                {industries.length > NO_OF_BLOCKS && (
                  <button
                    type="button"
                    onClick={
                      firstJobsIndex === industries.length
                        ? resetFirst
                        : LoadMoreFirst
                    }
                    className="site_btn text view_more_new mt-3"
                  >
                    {firstJobsIndex === industries.length
                      ? "View Less"
                      : "View All"}
                  </button>
                )}
              </FilterBox>
            </div>

            <div className="col-md-4">
              <FilterBox
                title="Location"
                name="location"
                openFilter={openFilter}
                toggleFilterBox={toggleFilterBox}
              >
                <ul className="ctg_lst">
                  {filteredLocations.map((city, key) => (
                    <li key={key}>
                      <label htmlFor={"city-" + city.id}>
                        <input
                          type="checkbox"
                          value={city.id}
                          id={"city-" + city.id}
                          name="city"
                          onChange={handleCityChange}
                          checked={
                            citiesFilter[city.id] ||
                            citiesFilter["city-" + city.id]
                          }
                        />
                        {city.title}
                        {city.count ? <span> ({city.count})</span> : null}
                      </label>
                    </li>
                  ))}
                </ul>

                {cities.length > NO_OF_BLOCKS && (
                  <button
                    type="button"
                    onClick={
                      secondJobsIndex === cities.length
                        ? resetSecond
                        : LoadMoreSecond
                    }
                    className="site_btn text view_more_new mt-3"
                  >
                    {secondJobsIndex === cities.length
                      ? "View Less"
                      : "View All"}
                  </button>
                )}
              </FilterBox>
            </div>

            {is_global === 0 && (
              <div className="col-md-4">
                <FilterBox
                  title="Suitable For"
                  name="suitable"
                  openFilter={openFilter}
                  toggleFilterBox={toggleFilterBox}
                >
                  <ul className="ctg_lst">
                    <li>
                      <label htmlFor="visa_acceptance">
                        <input
                          type="checkbox"
                          id="visa_acceptance"
                          name="visa_acceptance"
                          onClick={handleSetVisaAcceptance}
                          checked={visaAcceptance}
                        />
                        Graduate Visa holders
                      </label>
                    </li>

                    <li>
                      <label htmlFor="applicants_outside_uk">
                        <input
                          type="checkbox"
                          id="applicants_outside_uk"
                          name="applicants_outside_uk"
                          onClick={handleSetApplicantsOutUk}
                          checked={applicantsOutUk}
                        />
                        Applicants based outside the UK
                      </label>
                    </li>
                  </ul>
                </FilterBox>
              </div>
            )}

            {/* <div className="col-md-4">
              <SelectBox
                val={[
                  {
                    title: "Student Jobs",
                    options: ["Internships", "Part-Time", "Fresh Graduates"],
                  },
                  {
                    title: "Experienced Hire Jobs",
                    options: ["Mid Level", "Senior Level", "Manager"],
                  },
                ]}
                placeholder="Experience Level"
              />
            </div>
            <div className="col-md-4">
              <SelectBox
                val={[
                  "Construction & Engineering",
                  "Consulting",
                  "Financial Services",
                  "Legal Services",
                ]}
                placeholder="Industry"
              />
            </div>
            <div className="col-md-4">
              <SelectBox
                val={["London", "Manchester", "Liverpool", "Birmingham"]}
                placeholder="Location"
              />
            </div> */}
            {/* <div className="col-md-12">
              <label htmlFor="" className="mb-3">
                Only show jobs that are suitable for:
              </label>
              <div className="form_blk lbl_btn">
                <input type="checkbox" name="" id="" />
                <label htmlFor="">Overseas Applicants</label>
              </div>
              <div className="form_blk lbl_btn">
                <input type="checkbox" name="" id="" />
                <label htmlFor="">Graduate/HPI Visa Holders</label>
              </div>
              <div className="form_blk lbl_btn">
                <input type="checkbox" name="" id="" />
                <label htmlFor="">
                  Skilled/Health & Care Worker Visa Holders
                </label>
              </div>
            </div> */}
          </div>
          <div className="in_blk mt-4">
            <div className="btn_blk text-left d-flex gap-3">
              <button
                type="button"
                className="site_btn"
                onClick={handleApplyFilters}
                disabled={isSearching}
              >
                <FormProcessingSpinner isFormProcessing={isSearching} />
                Apply Filters
              </button>
            </div>
          </div>

          <hr />
          <div className="bottom_filter">
            <div className="active_filter">
              <span>Active filter:</span>

              {getActiveFilters().length === 0 ? (
                <span className="ms-2 text-muted">None</span>
              ) : (
                getActiveFilters().map((filter) => (
                  <button
                    type="button"
                    key={filter.key}
                    onClick={filter.onRemove}
                  >
                    {filter.label}
                    <img src="/images/icon_cross.png" alt="" />
                  </button>
                ))
              )}
            </div>

            <button
              type="button"
              className="clear_filter"
              onClick={handleClearAllFilter}
            >
              <img src="/images/icon_mini_refresh.png" alt="" />
              Clear all filter
            </button>
          </div>
        </div>
      </form>

      <div className="top_head">
        <div className="text">
          <h3>{totalJobs} Jobs Found</h3>
          <p>Based on your search criteria</p>
        </div>
        <div className="sort">
          Sort by:
          <select
            name=""
            id="sort_by"
            value={sortBy}
            className="input"
            onChange={(e) => handleSortByChange(e.target.value)}
          >
            <option value="desc">Most Recent</option>
            <option value="asc">Least Recent</option>
          </select>
        </div>
      </div>
    </>
  )
}
